const localizationQuery = `
  query {
    localization {
      availableCountries {
        isoCode
        name
        currency {
          isoCode
          symbol
          name
        }
      }
    }
  }
`

export default localizationQuery
